<template>
    <div v-bind:style="{ marginBottom: !value.random ? '8px' : '0' }" class="subject-container">
        <div class="avatar-container" v-if="!value.random">
            <avatar :size="35" class="avatar" :src="value.picture" :username="value.title" />
            <span class="title">{{ value.title }}</span>
        </div>
        <div class="description" v-if="value.description" v-html="value.description" />
    </div>
</template>
<script>
import Avatar from 'vue-avatar'
export default {
    components: {
        Avatar,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style lang="sass" scoped>
.subject-container
    display: flex
    flex-direction: column
    justify-content: center

    .avatar-container
        display: flex
        align-items: center

        .avatar
            margin-right: 8px

        .title
            font-weight: 500
            line-height: 1.2
            font-size: 1.09375rem

    ::v-deep .description
        text-align: justify
        margin-left: 3px
        margin-bottom: 12px

        *
            margin: 0
</style>
